/* @moldura padrao */
/**
 * Central de Ajuda (`/ajuda`) — casca no estilo do tema (hero + busca +
 * categorias). Base: `company/CompanyHelpCenter` do AdminUX, enxugada. Os itens
 * com artigo escrito abrem a leitura; os demais mostram "em breve".
 */
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { SECOES, temArtigo } from './artigos';
import { CustomMolduraPagina } from '@/components/CustomMolduraPagina';

export function AjudaPage() {
  const navigate = useNavigate();
  const [busca, setBusca] = useState('');

  const secoes = useMemo(() => {
    const q = busca.trim().toLowerCase();
    if (!q) return SECOES;
    return SECOES.map((s) => ({
      ...s,
      artigos: s.artigos.filter(
        (a) =>
          a.titulo.toLowerCase().includes(q) || s.nome.toLowerCase().includes(q),
      ),
    })).filter((s) => s.artigos.length > 0);
  }, [busca]);

  const abrir = (slug: string, titulo: string) => {
    if (temArtigo(slug)) navigate(`/ajuda/${slug}`);
    else toast.info('Artigo em breve', { description: titulo });
  };

  return (
    <CustomMolduraPagina
      titulo="Central de Ajuda"
      descricao="Como o sistema funciona, passo a passo."
      semCaminho
    >

      {/* Hero + busca */}
      <div className="card adminuiux-card bg-theme-1 text-white mb-3 mb-lg-4">
        <div className="card-body text-center py-4 py-lg-5">
          <h2 className="mb-2">Como podemos ajudar?</h2>
          <p className="mb-3 opacity-75">
            Procure pelo que você quer fazer — ou escolha uma seção abaixo.
          </p>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="input-group card flex-row">
                <span className="input-group-text bg-transparent border-0">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  className="form-control form-control-lg border-0"
                  type="search"
                  placeholder="Ex.: imprimir roteiro, abrir OS, lançar despesa…"
                  value={busca}
                  onChange={(e) => setBusca(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Categorias */}
      <div className="row">
        {secoes.map((s) => (
          <div className="col-md-6 col-xl-4 mb-3 mb-lg-4" key={s.nome}>
            <div className="card adminuiux-card h-100">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <span className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1">
                    <i className={`bi ${s.icone}`}></i>
                  </span>
                  <h6 className="mb-0">{s.nome}</h6>
                </div>
                <div className="list-group list-group-flush">
                  {s.artigos.map((a) => {
                    const pronto = temArtigo(a.slug);
                    return (
                      <button
                        key={a.slug}
                        type="button"
                        className="list-group-item list-group-item-action border-0 px-0 py-2 text-start bg-transparent d-flex align-items-center"
                        onClick={() => abrir(a.slug, a.titulo)}
                      >
                        <i
                          className={`bi ${
                            pronto
                              ? 'bi-file-earmark-text text-theme-1'
                              : 'bi-file-earmark text-secondary'
                          } me-2`}
                        ></i>
                        <span className={pronto ? '' : 'text-secondary'}>
                          {a.titulo}
                        </span>
                        {!pronto && (
                          <span className="badge bg-secondary-subtle text-secondary ms-auto">
                            em breve
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ))}
        {secoes.length === 0 && (
          <div className="col-12">
            <p className="text-secondary text-center py-4">
              Nada encontrado para “{busca}”.
            </p>
          </div>
        )}
      </div>
    </CustomMolduraPagina>
  );
}
